import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.scss";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FirebaseService } from "../../services/firebase.service";
import Button from "../../components/Button";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [password, setPassword] = useState("");
  const [user, loading] = useAuthState(auth);
  const [logging, setLogging] = useState(false);
  const navigate = useNavigate();

  const checkUserPersona = async () => {
    const userRef = doc(db, "users", user?.uid || "");
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();

    if (userData?.personaId) {
      navigate("/dashboard");
    } else {
      navigate("/personas");
    }
  };

  const login = async () => {
    try {
      if (email && password) {
        setLogging(true);
        const loggedUser = await FirebaseService.logInWithEmailAndPassword(
          email,
          password
        );
        const userRef = doc(db, "users", loggedUser?.user.uid || "");
        const userSnap = await getDoc(userRef);
        const userData = userSnap.data();

        if (userData?.personaId) {
          navigate("/dashboard");
        } else {
          navigate("/personas");
        }
      } else {
        alert("Please fill your email and password");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleResize = () => {
    if (window.innerWidth <= 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (loading) return;

    if (user && !logging) navigate("/");
  }, [user, loading]);

  return (
    <div
      className={`row login-page page-wrapper ${
        !isMobile ? "desktop-background-image" : ""
      }`}
    >
      <div className="col m4">
        {isMobile && (
          <Link className="back-button" to="/">
            {"<"}Back
          </Link>
        )}
        <Header logoColor={`${isMobile ? "white" : "black"}`} />
      </div>
      <div className="col m4 section-wrapper">
        <div className="auth-form">
          <div className="input-field">
            <input
              id="email-or-username"
              type="text"
              className="validate"
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="email-or-username">Email or Username</label>
            <span className="helper-text" data-error="Required"></span>
          </div>
          <div className="input-field">
            <input
              id="password-input"
              type="password"
              className="validate"
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="password-input">Password</label>
            <span className="helper-text" data-error="Required"></span>
          </div>
          <Button
            type="primary"
            size="large"
            disabled={!email || !password}
            onClick={login}
          >
            LOG IN
          </Button>
          <div className="forgot-password-label">
            <Link to="/reset">Forgot Password?</Link>
          </div>
        </div>
      </div>
      {!isMobile && (
        <div className="col m4">
          <div className="text-main">
            Don’t have an xID yet?{" "}
            <Link to="/register">Let’s get started.</Link>
          </div>
          <Footer />
        </div>
      )}
    </div>
  );
};
